module.exports = __webpack_public_path__ + "static/greeting_img2@2x-bc841d076dc910358df0cb0411ded4ce.png";